import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var DegradeError = /*#__PURE__*/function (_Error) {
  function DegradeError() {
    var _this;
    _classCallCheck(this, DegradeError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DegradeError, [].concat(args));
    _defineProperty(_this, "isDegraded", true);
    return _this;
  }
  _inherits(DegradeError, _Error);
  return _createClass(DegradeError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var DEGRADE_TIMEOUT_MS = 6000;
var DEGRADE_ERROR = new DegradeError('Promise is degraded');
export var DegradablePromise = /*#__PURE__*/function () {
  function DegradablePromise(wrapped, degradationCallback) {
    var _this2 = this;
    _classCallCheck(this, DegradablePromise);
    _defineProperty(this, "degradeInternal", function () {
      // Default throws an error as this should never happen
      throw new Error('Programming error, cancelling promise is not properly rejected');
    });
    _defineProperty(this, "timeout", function () {
      _this2.degradeInternal();
    });
    _defineProperty(this, "promise", function () {
      return _this2.degradablePromiseInternal;
    });
    var degrader = new Promise(function (_, reject) {
      _this2.degradeInternal = function () {
        reject(DEGRADE_ERROR);
        degradationCallback();
      };
    });

    // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
    var wrappedFinally = wrapped.finally(function () {
      if (_this2.degradeTimeout) {
        clearTimeout(_this2.degradeTimeout);
      }
    });
    var wrapper = Promise.race([wrappedFinally, degrader]);
    this.degradablePromiseInternal = wrapper;
    this.degradeTimeout = setTimeout(this.timeout, DEGRADE_TIMEOUT_MS);
  }
  return _createClass(DegradablePromise, null, [{
    key: "from",
    value: function from(wrapped) {
      var degradationCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      return new DegradablePromise(wrapped, degradationCallback);
    }
  }]);
}();